import { links } from "./links";

export const degrees = {
    graduateDiploma: [
        {
            title: "Place and Nature-Based Experiential learning",
            description: 'A contemporary curriculum developed in collaboration with school districts and consultation with Faculty of Education faculty members.',
            // degrees: [],
        },
        {
            title: "Maker Pedagogy",
            description: 'A contemporary curriculum developed in collaboration with school districts and consultation with Faculty of Education faculty members.',
            // degrees: [],
        },
        {
            title: "Inclusive Education",
            description: 'A contemporary curriculum developed in collaboration with school districts and consultation with Faculty of Education faculty members.',
            // degrees: [],
        },
        {
            title: "French Education",
            description: 'A contemporary curriculum developed in collaboration with school districts and consultation with Faculty of Education faculty members.',
            // degrees: [],
        },
        {
            title: "Teaching for Social Justice",
            description: 'A contemporary curriculum developed in collaboration with school districts and consultation with Faculty of Education faculty members.',
            // degrees: [],
        },
        {
            title: "Social Emotional Learning",
            description: 'A contemporary curriculum developed in collaboration with school districts and consultation with Faculty of Education faculty members.',
            // degrees: [],
        },
        {
            title: "Learning in the Early Years",
            description: 'A contemporary curriculum developed in collaboration with school districts and consultation with Faculty of Education faculty members.',
            // degrees: [],
        },
        {
            title: "Indigenous Education",
            description: 'A contemporary curriculum developed in collaboration with school districts and consultation with Faculty of Education faculty members.',
            // degrees: [],
        },
        {
            title: "Language Literacy and Learning",
            description: 'A contemporary curriculum developed in collaboration with school districts and consultation with Faculty of Education faculty members.',
            // degrees: [],
        },
    ],
    graduateStudies: [
        {
            title: "Arts Education",
            description: 'Develop critical knowledge of arts theory and practice across a range of arts disciplines.',
            url: links.graduateStudies.areasOfStudy.artsEducation,
            degrees: [
                {
                    name: 'Master of Arts (MA) in Arts Education',
                    url: ''
                },
                {
                    name: 'Master of Education (MEd) in Arts Education',
                }
            ],
        },
        {
            title: "Counselling Psychology",
            description: 'Prepare for a career as a professional counsellor in community and educational settings.',
            url: links.graduateStudies.areasOfStudy.counsellingPsych,
            degrees: [
                {
                    name: 'Master of Arts (MA) in Counselling Psychology',
                },
                {
                    name: 'Master of Education (MEd) in Counselling Psychology'
                }
            ],
        },
        {
            title: "Curriculum & Instruction",
            description: 'Critically examine current educational curriculum theory, research and practice.',
            url: links.graduateStudies.areasOfStudy.curriculimInstruction,
            degrees: [
                {
                    name: 'Curriculum and Instruction Foundations (MA, MEd)'
                },
                {
                    name: 'Curriculum and Instruction: Equity Studies in Education (MA, MEd)'
                },
                {
                    name: 'Master of Education (MEd) in Educational Practice'
                },
                {
                    name: 'Master of Education (MEd) in Curriculum & Instruction'
                }
            ],
        },
        {
            title: "Equity Studies in Education",
            description: 'Study and develop expertise in an equity framework for education in the classroom and in society.',
            url: links.graduateStudies.areasOfStudy.equityStudies,
            degrees: [
                {
                    name: 'Master of Arts (MA) in Equity Studies in Education'
                },
                {
                    name: 'Master of Education (MEd) in Equity Studies in Education'
                }
            ],
        },
        {
            title: "Educational Psychology",
            description: 'Develop broad knowledge of the field of educational psychology and its relevance to education.',
            url: links.graduateStudies.areasOfStudy.educationalPsych,
            degrees: [
                {
                    name: 'Master of Arts (MA) in Educational Psychology'
                },
                {
                    name: 'Master of Education (MEd) in Educational Psychology'
                }
            ],
        },
        {
            title: "Educational Leadership",
            description: 'Deepen your theoretical understanding, strengthen your practice and advance your career.',
            url: links.graduateStudies.areasOfStudy.educationalLeadership,
            degrees: [
                {
                    name: 'Master of Education (MEd) in Educational Leadership'
                }
            ],
        },
        {
            title: "Educational Technology & Learning Design",
            description: 'Focus on the study, research and integration of technological innovations to understand and support learning.',
            url: links.graduateStudies.areasOfStudy.eduTechLearningDesign,
            degrees: [
                {
                    name: 'Master of Arts (MA) in Educational Technology & Learning Design'
                },
                {
                    name: 'Master of Education (MEd) in Educational Technology & Learning Design'
                }
            ],
        },
        {
            title: "Language & Societies",
            description: 'Develop advanced theoretical and practical knowledge of issues in teaching languages in a globalized world.',
            url: links.graduateStudies.areasOfStudy.languageSocieties,
            degrees: [
                {
                    name: 'Master of Education (MEd) in Teaching English as an Additional Language (TEAL)'
                },
                {
                    name: 'Master of Arts (MA) in Teaching English as an Additional Language (TEAL)'
                },
                {
                    name: 'Master of Education (MEd) in Teaching Languages in Global Contexts'
                }
            ],
        },
        {
            title: "Mathematics Education",
            description: 'Develop an understanding of mathematics teaching and learning for research and professional practice.',
            url: links.graduateStudies.areasOfStudy.mathsEducation,
            degrees: [
                {
                    name: 'Master of Education (MEd) in Innovations in Mathematics Education'
                },
                {
                    name: 'Master of Science (MSc) in Secondary Mathematics Education'
                },
                {
                    name: 'Master of Education (MEd) in Secondary Mathematics Education'
                }
            ],
        },
        {
            title: 'Programmes en langue francais',
            url: links.graduateStudies.areasOfStudy.programmesLanguesFrancaise,
            description: 'Discover graduate programs en langue francais.',
            degrees: [
                {
                    name: 'Maîtrise en éducation en français MEd, MA (campus de SFU)',
                },
                {
                    name: 'Maîtrise en éducation en français MEd, MA (campus de SFU)'
                }
            ],
        },
        {
            title: 'Themes in Community',
            url: links.graduateStudies.areasOfStudy.themesInCommunity,
            description: 'Innovative, theme-based graduate programs offered within Community and on campus.'
        }
    ],
    postBach: [
        {
            title: "Counselling and Human Development",
            description: 'A focused introduction to the core knowledge bases involved in counselling.',
            url: 'http://www.sfu.ca/students/calendar/programs/counselling-and-human-development/post-baccalaureate-diploma.html',
        },
        {
            title: "Early Learning",
            description: 'For students wishing to work with children aged three through eight.',
            url: 'http://www.sfu.ca/students/calendar/programs/early-learning/post-baccalaureate-diploma.html',
        },
        {
            title: "Environmental Education",
            description: 'For practicing teachers who want to help students develop a greater awareness and understanding of the environment.',
            url: 'http://www.sfu.ca/students/calendar/programs/environmental-education/post-baccalaureate-diploma.html',
        },
        {
            title: "Education (General)",
            description: 'An opportunity to design and pursue a program of individualized study.',
            url: 'http://www.sfu.ca/students/calendar/programs/education-general-/post-baccalaureate-diploma.html',
        },
        {
            title: "French and Education",
            description: 'A set of courses for practicing or future French teachers.',
            url: 'http://www.sfu.ca/students/calendar/programs/french-and-education/post-baccalaureate-diploma.html',
        },
        {
            title: "Special Education",
            description: 'For educators and health care professionals who work with children and adults with disabilities.',
            url: 'http://www.sfu.ca/students/calendar/programs/special-education/post-baccalaureate-diploma.html',
        },
    ],
    // doctoral: [
    //     {
    //         title: "Arts Education",
    //         description: 'Develop critical knowledge of arts theory and practice across a range of arts disciplines.',
    //         degrees: [
    //             {
    //                 name: 'Arts Education (PhD)'
    //             },
    //             {
    //                 name: 'Educational Doctorate in Transformational Change (EdD)'
    //             }
    //         ],
    //     },
    //     {
    //         title: "Educational Leadership",
    //         description: 'Deepen your theoretical understanding, strengthen your practice and advance your career.',
    //         degrees: [
    //             {
    //                 name: 'Educational Leadership (PhD)'
    //             }
    //         ],
    //     },
    //     {
    //         title: "Educational Psychology",
    //         description: 'Prepare for a career as a professional counsellor in community and educational settings.',
    //         degrees: [
    //             {
    //                 name: 'Educational Psychology (PhD)'
    //             }
    //         ],
    //     },
    //     {
    //         title: "Educational Technology & Learning Design",
    //         description: 'Focus on the study, research and integration of technological innovations to understand and support learning.',
    //         degrees: [
    //             {
    //                 name: 'Educational Technology & Learning Design (PhD)'
    //             }
    //         ],
    //     },
    //     {
    //         title: "Educational Theory and Practice: Curriculum & Pedagogy",
    //         description: 'Expand your understanding or scope of practice within formal and informal sectors of education.',
    //         degrees: [
    //             {
    //                 name: 'Educational Theory and Practice: Curriculum and Pedagogy Stream (PhD)'
    //             }
    //         ],
    //     },
    //     {
    //         title: "Educational Theory and Practice: Philosophy of Education",
    //         description: 'Explore the deeper questions related to individual, cultural and environmental aspects of education.',
    //         degrees: [
    //             {
    //                 name: 'Educational Theory and Practice: Philosophy of Education (PhD)'
    //             }
    //         ],
    //     },
    //     {
    //         title: "Languages, Culture and Literacies, PhD",
    //         description: 'Develop advanced theoretical and practical knowledge of issues in teaching languages in a globalized world.',
    //         degrees: [
    //             {
    //                 name: 'Languages, Cultures, & Literacies (PhD)'
    //             }
    //         ],
    //     },
    //     {
    //         title: "Langues, cultures et literaties, (en français)",
    //         description: 'Ce programme vous permettra d’explorer les fondements théoriques et empiriques des études en contexte de contact et d’altérité des langues et des cultures.',
    //         degrees: [
    //             {
    //                 name: 'Langues, cultures et littératies PhD (en français)'
    //             },
    //             {
    //                 name: 'Doctorat en leadership éducationnel (EdD)'
    //             }
    //         ],
    //     },
    //     {
    //         title: "Mathematics Education",
    //         description: 'Develop an understanding of mathematics teaching and learning for research and professional practice.',
    //         degrees: [
    //             {
    //                 name: 'Mathematics Education (PhD)'
    //             }
    //         ],
    //     },
    // ],
};
